import React from 'react'
import { Props } from './types'

export const Reset: React.FC<Props> = (props) => {
  return (
    <svg
      version="1.1"
      x="0px"
      y="0px"
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      {...props}
    >
      <path d="M8,15.54c-2.82,0-5.31-1.7-6.33-4.32l1.86-.73c.72,1.85,2.48,3.05,4.47,3.05,2.64,0,4.79-2.15,4.79-4.79s-2.15-4.79-4.79-4.79c-.66,0-1.3.13-1.9.39l-.79-1.84c.85-.37,1.76-.56,2.69-.56,3.75,0,6.79,3.05,6.79,6.79s-3.05,6.79-6.79,6.79Z" />
      <polygon points="8.38 5.71 1.61 7.12 3.79 .56 8.38 5.71" />
    </svg>
  )
}
